import { onMounted, onBeforeUnmount, ref, reactive, watch } from "vue";
import BannerSwiper from "@/components/BannerSwiper/index.vue";
import Contact from "@/pages/contactUs/components/contact.vue";
import Occupation from "@/pages/contactUs/components/occupation.vue";
import Culture from "@/pages/contactUs/components/culture.vue";
export default {
  components: {
    BannerSwiper: BannerSwiper,
    // Contact,
    Occupation: Occupation,
    Culture: Culture
  },
  name: "Index",
  setup: function setup() {
    var num = ref(4); // 根据视口宽度动态修改 swiper 展示数量

    var viewportWidth = ref(window.innerWidth);

    var updateViewportWidth = function updateViewportWidth() {
      viewportWidth.value = window.innerWidth;
    }; // 在组件挂载后开始监听窗口大小变化


    onMounted(function () {
      window.addEventListener("resize", updateViewportWidth);

      if (viewportWidth.value > 1000) {
        num.value = 4;
      }

      if (viewportWidth.value < 1000) {
        num.value = 2;
      }

      if (viewportWidth.value < 768) {
        num.value = 1;
      }
    });
    watch(viewportWidth, function (newValue) {
      if (newValue > 1000) {
        num.value = 4;
      }

      if (newValue < 1000) {
        num.value = 2;
      }

      if (newValue < 768) {
        num.value = 1;
      }
    }); // 在组件卸载前移除事件监听器

    onBeforeUnmount(function () {
      window.removeEventListener("resize", updateViewportWidth);
    });
    watch(num, function (newValue) {
      //  console.log(newValue,'变化了吗');;
      num.value = newValue;
    });
    var bannerList = reactive([{
      id: 0,
      // new_banner_ctu_02
      // imageUrl: "https://cdn.tenacia.com/base/tenacia-img/new_banner_ctu_02.jpg",
      imageUrl: require('./image/1-2.jpg')
    }]);
    return {
      bannerList: bannerList,
      num: num
    };
  }
};